// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__gHyvI","log":"ModalInventoryLogs_log__2pBff","date":"ModalInventoryLogs_date__1wsr2","userName":"ModalInventoryLogs_userName__10RrB"};